var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"container"},[_c('el-header',[_c('sectionHeader')],1),_c('el-container',[_c('el-aside',[_c('sectionSidemenu',{on:{"menuLoadCallback":_vm.menuLoadCallback}})],1),_c('el-main',[(_vm.menuLoaded)?_c('router-view'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }